module.exports = __webpack_public_path__ + "static/media/shell32_14.39a48327.ico";